import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material/material.module';
import { SharedModule } from '../shared/shared.module';
import { ProjectRoutingModule } from './project-routing.module';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { DirectivesModule } from '../directives/directives.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [PageNotFoundComponent],
  imports: [CommonModule, MaterialModule, SharedModule, ProjectRoutingModule, DirectivesModule, ReactiveFormsModule],
})
export class ProjectModule {}
